"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GuardCheckCircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GuardCheckCircleLinear = function GuardCheckCircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 0a30 30 0 100 60 30 30 0 000-60zm0 58a28 28 0 110-56.001A28 28 0 0130 58zm11.19-40.47a25.002 25.002 0 01-5.74-.38 7.72 7.72 0 01-4.11-2.57 1.84 1.84 0 00-2.68 0 7.72 7.72 0 01-4.11 2.57 25.001 25.001 0 01-5.74.38A1.82 1.82 0 0017 19.36v8.86c0 3.36 1.26 11.53 12.13 17.56a1.83 1.83 0 001.74 0C41.74 39.75 43 31.58 43 28.22v-8.86a1.82 1.82 0 00-1.81-1.83zM41 28.22C41 31 40 38.38 30 44c-10-5.62-11-13-11-15.78v-8.69a26.13 26.13 0 006-.44 9.64 9.64 0 005-3 9.64 9.64 0 005 3 26.13 26.13 0 006 .44v8.69zm-6.71-1.93a1.004 1.004 0 111.42 1.42l-6 6a1 1 0 01-1.42 0l-3-3a1.004 1.004 0 111.42-1.42l2.29 2.3 5.29-5.3z",
    fill: "url(#GuardCheckCircleLinear_svg__GuardCheckCircleLinear_svg__paint0_linear_17373_95600)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "GuardCheckCircleLinear_svg__GuardCheckCircleLinear_svg__paint0_linear_17373_95600",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.GuardCheckCircleLinear = GuardCheckCircleLinear;
var _default = GuardCheckCircleLinear;
exports.default = _default;